<template>
  <div class="cardList-dealer">
    <div v-if="!doubleColShows" class="list-item list-item-dealer">
      <van-checkbox
        v-if="isCheckOpen"
        :name="item.id"
        shape="square"
        checked-color="#000"
      ></van-checkbox>
      <van-radio v-if="feedBackCheckOpen" :name="index"></van-radio>
      <div
        class="dealer"
        :class="isCheckOpen || feedBackCheckOpen ? 'dealer-294' : 'dealer-325'"
        @click="
          !isCheckOpen &&
            !feedBackCheckOpen &&
            toDetailPage('dealerDetail', item, index)
        "
      >
        <div class="dealer-label">
          {{ item.dealerType === '1' ? '服务商' : '代理商' }}
        </div>
        <img
          v-if="
            item.latitude &&
              item.longitude &&
              item.latitude !== '0.0' &&
              item.longitude !== '0.0'
          "
          class="dealer-location-icon"
          src="@/assets/img/vSearch/icon-location.png"
          alt=""
          @click.stop="openMap(item)"
        />
        <div class="dealer-top">
          <div class="dealer-title">{{ item.name }}</div>
          <div class="dealer-address">地址：{{ item.address || '/' }}</div>
          <div v-if="item.dealerType === '2'">
            销售热线：{{ item.salePhone || '/' }}
          </div>
          <div v-if="item.dealerType === '1'">
            售后热线：{{ item.servicePhone || '/' }}
          </div>
          <div v-if="item.dealerType === '1'">
            24小时救援电话：{{ item.hotPhone || '/' }}
          </div>
          <div
            v-if="isInApp && item.dealerType !== '1'"
            class="more"
            @click.stop="openJsbridge(item)"
          >
            了解更多
          </div>
        </div>
        <div class="dealer-bottom">
          <span
            v-show="!isCheckOpen && !notInQw"
            @click.stop="
              share('dealerDetail', {
                ...item,
                offset:
                  (searchParams.pageIndex - 1) * searchParams.pageSize +
                  index +
                  1,
              })
            "
          >
            <img
              style="width: 18px;height: 15px;"
              :src="proj === 'audi' ? audiSendIcon : sendIcon"
              alt=""
            />转发
          </span>
        </div>
        <div v-if="item.tags" class="dealer-tags">
          <CardListTags :tags="item.tags ? item.tags.split(',') : []" />
        </div>
      </div>
    </div>
    <div v-if="doubleColShows" class="list-item list-item-picture">
      <van-checkbox
        v-if="isCheckOpen"
        :name="item.id"
        shape="square"
        checked-color="#000"
      ></van-checkbox>
      <van-radio v-if="feedBackCheckOpen" :name="index"></van-radio>
      <div
        class="picture"
        @click="
          !isCheckOpen &&
            !feedBackCheckOpen &&
            toDetailPage(
              'videoDetail',
              item,
              index,
              (searchParams.pageIndex - 1) * searchParams.pageSize + index + 1
            )
        "
      >
        <div class="image">
          <img
            v-lazy="item.hasImageUrl ? item.imageUrl : audioBg"
            :src="item.hasImageUrl ? item.imageUrl : audioBg"
            alt=""
          />
          <span v-if="proj === 'audi'" class="media-time-wrapper">
            <van-icon name="play" />
            <span class="media-time">{{
              getDurationFormat(item.duration)
            }}</span>
          </span>
        </div>
        <div class="card-bottom-wrapper">
          <div class="name keywords-mark-f00" v-html="item.title"></div>
          <img
            v-show="!isCheckOpen && !notInQw"
            style="width: 18px;height: 15px;"
            :src="proj === 'audi' ? audiSendIcon : sendIcon"
            alt=""
            @click.stop="
              share('dealerDetail', {
                ...item,
                offset:
                  (searchParams.pageIndex - 1) * searchParams.pageSize +
                  index +
                  1,
              })
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import audioBg from '@/assets/img/vSearch/audioBg.png';
import { getUrlParamsObj } from '@/scripts/utils';
import sendIcon from '@/assets/img/vSearch/icon_share.png';
import audiSendIcon from '@/assets/img/vSearch/send_icon.png';
import CardListTags from '@/components/CardList-tags.vue';
export default {
  name: 'Media',
  components: { CardListTags },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: () => {},
    },
    doubleColShows: {
      type: Boolean,
      default: false,
    },
    isCheckOpen: {
      type: Boolean,
      default: false,
    },
    feedBackCheckOpen: {
      type: Boolean,
      default: false,
    },
    searchParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      sendIcon,
      audiSendIcon,
      notInQw: false,
      proj: process.env.VUE_APP_PROJ,
      audioBg,
      isInApp: false,
    };
  },
  created() {
    this.notInQw = getUrlParamsObj().notInQw || '';
    const from = getUrlParamsObj().from || '';
    console.log('aaaaaaaa', from);
    if (
      from &&
      (from.toLocaleLowerCase().indexOf('app') >= 0 ||
        from.indexOf('奥迪商城渠道') >= 0)
    ) {
      this.isInApp = true;
    }
  },
  mounted() {
    if (document.querySelectorAll('#tags')) {
      document.querySelectorAll('#tags').forEach((item) => {
        item.addEventListener(
          'touchmove',
          function(event) {
            event.stopPropagation();
          },
          true
        );
      });
    }
  },
  methods: {
    openJsbridge(item) {
      try {
        if (process.env.VUE_APP_ENV !== 'prod') {
          window.webViewJavascriptBridge.callHandler(
            'openRoutePath',
            {
              path:
                'scaudi://mall/order?url=https://uataudi-embedded-wap.saic-audi.mobi/favoritecar/index.html#/dealerDetail?dealerCode=' +
                item.code +
                '&env=app',
            },
            function(err, data) {
              console.log('jsbridge:' + err);
            }
          );
        } else {
          window.webViewJavascriptBridge.callHandler(
            'openRoutePath',
            {
              path:
                'scaudi://mall/order?url=https://audi-embedded-wap.saic-audi.mobi/favoritecarv6/index.html#/dealerDetail?dealerCode=' +
                item.code +
                '&env=app',
            },
            function(err, data) {
              console.log('jsbridge:' + err);
            }
          );
        }
      } catch (err) {
        console.log('try:' + err);
      }
    },
    getDurationFormat(duration) {
      if (!duration) return '--:--';
      const second = duration % 60;
      const minute = parseInt(duration / 60) % 60;
      const hour = parseInt(duration / 60 / 60);
      return `${hour > 9 ? hour : '0' + String(hour)}:${
        minute > 9 ? minute : '0' + String(minute)
      }:${second > 9 ? second : '0' + String(second)}`;
    },
    timeTypeFomate(date, type = 'YYYY-MM-DD HH:mm:ss') {
      if (new Date(date).getDate() === new Date().getDate()) {
        return '今日发布';
      } else if (
        new Date().getTime() - new Date(date).getTime() <=
        7 * 24 * 60 * 60 * 1000
      ) {
        const dayNum = Math.ceil(
          (new Date().getTime() - new Date(date).getTime()) /
            (24 * 60 * 60 * 1000)
        );
        console.log(dayNum);
        return `${dayNum}天前`;
      } else {
        return moment(new Date(Number(date))).format(type);
      }
    },

    toDetailPage(pathName, item, index) {
      this.$emit('toDetailPage', pathName, item, index);
    },
    share(pathName, item) {
      this.$emit('share', pathName, item);
    },
    openMap(item) {
      this.$router.push({
        path: '/vSearch/map',
        query: {
          latitude: item.latitude,
          longitude: item.longitude,
          name: item.name,
          addr: item.address,
        },
      });
      // window.open(`https://apis.map.qq.com/uri/v1/marker?marker=coord:${parseFloat(item.latitude)},${parseFloat(item.longitude)};title:${item.name};addr:${item.address}&referer=myapp`)
      // if (this._userAgentType().platform === 'pc' || self !== top || this.notInQw) {
      //   window.open(`https://apis.map.qq.com/uri/v1/marker?marker=coord:${parseFloat(item.latitude)},${parseFloat(item.longitude)};title:${item.name};addr:${item.address}&referer=myapp`)
      // }
      // else {
      //   try {
      //     window.wx.openLocation({
      //       latitude: parseFloat(item.latitude), // 纬度，浮点数，范围为90 ~ -90
      //       longitude: parseFloat(item.longitude), // 经度，浮点数，范围为180 ~ -180。
      //       name: item.name, // 位置名
      //       address: item.address, // 地址详情说明
      //       scale: 16 // 地图缩放级别,整形值,范围从1~28。默认为16
      //     })
      //   }
      //   catch (error) {
      //     console.log('位置报错', error)
      //   }
      // }
    },
  },
};
</script>
<style lang="less" scope>
.more {
  position: absolute;
  padding: 0px 10px;
  font-size: 12px;
  right: 0px;
  bottom: 0px;
  border: 0.5px solid #dddddd;
}
.list-item-dealer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .dealer-294 {
    width: 90%;
    transition-duration: 0.1s;
  }
  .dealer-325 {
    width: 100%;
    transition-duration: 0.1s;
  }
  .van-checkbox {
    width: 16px;
    .van-checkbox__icon {
      .van-icon {
        border-color: rgba(0, 0, 0, 0.5);
        width: 16px;
        height: 16px;
        line-height: 16px;
      }
      .van-icon::before {
        font-size: 12px;
        position: relative;
        top: -2px;
      }
    }
    .van-checkbox__label {
      display: none;
    }
  }
  .van-radio {
    width: 16px;
    .van-radio__icon {
      .van-icon {
        border-color: rgba(0, 0, 0, 0.5);
        width: 16px;
        height: 16px;
        line-height: 16px;
      }
      .van-icon::before {
        font-size: 12px;
        position: relative;
        top: -2px;
      }
    }
    .van-radio__icon--checked .van-icon {
      background-color: #000;
    }
    .van-radio__label {
      display: none;
    }
  }
}
.dealer {
  position: relative;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 13px;
  color: #888888;
  line-height: 28px;
  .dealer-label {
    position: absolute;
    top: 0;
    right: 0;
    background: #f5f5f5;
    border-radius: 0 0 0 13px;
    box-sizing: border-box;
    padding: 1.5px 4.8px 1.5px 9.2px;
  }
  .dealer-location-icon {
    position: absolute;
    top: 41px;
    right: 15px;
    width: 32px;
    height: 32px;
  }
  .dealer-top {
    padding: 15px;
  }
  .dealer-title {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 15px;
    color: #040404;
    line-height: 28px;
    max-width: calc(100% - 50px);
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }
  .dealer-address {
    max-width: calc(100% - 50px);
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }
  .dealer-bottom {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 6px;
    margin-right: 15px;
    span {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 13px;
      color: #040404;
      letter-spacing: 0;
      text-align: center;
      display: flex;
      align-items: center;
      img {
        margin-right: 4px;
      }
    }
  }
  .dealer-tags {
    box-sizing: border-box;
    padding: 0 15px 5px;
    margin-top: 11px;
    border-top: 1px solid #dddddd;
  }
}
</style>
